import { Const as SharedConst } from '@rt/shared/src';

const _Const = SharedConst();
export const Const = {
  ..._Const,
  BatchInviteMax: 100,
  RtMailDomain: 'righttouch.co.jp',
  Gcloud: {
    ..._Const.Gcloud,
    LocalConfigurationName: 'auth-local',
  },
  Postgres: {
    Database: 'auth',
    LocalCredentials: {
      User: 'admin',
      Pass: 'admin',
    },
  },
  AuditLogExport: {
    // 監査ログ基盤に TVF が存在する最初の月 (YYYYMM)。エクスポート可能月の下限。
    // apps/auth/packages/infra-tf/modules/audit-export の audit_month_start と一致させること。
    ServiceStartMonth: '202606',
  },
  LocalStorage: {
    LatestProjectId: '@rt-auth/latestProjectId',
    LatestOrganizationId: '@rt-auth/latestOrganizationId',
    LatestProductByProjectId: '@rt-auth/latestProductByProjectId',
    IsGnaviPinned: '@rt-auth/isGnaviPinned',
    GnaviWidth: '@rt-auth/gnaviWidth',
  },
};
